import { cn } from '../../utils/cn';

const toneStyles = {
  neutral: 'bg-status-neutral-soft text-fg-muted',
  // Contorneado en vez de relleno, para estados "cerrados sin resultado" (p. ej. un
  // retiro anulado). Comparte el gris con `neutral` a propósito —no es un error ni una
  // alerta— y se distingue por la forma, que es lo único disponible cuando dos estados
  // legítimamente comparten color.
  muted:   'bg-transparent text-fg-muted ring-1 ring-inset ring-status-neutral-soft',
  brand:   'bg-brand-50 text-brand-700',
  success: 'bg-status-success-soft text-status-success',
  error:   'bg-status-error-soft text-status-error',
  warning: 'bg-status-warning-soft text-status-warning',
  info:    'bg-status-info-soft text-status-info',
  cc:      'bg-status-cc-soft text-status-cc',
};

const dotStyles = {
  neutral: 'bg-status-neutral',
  muted:   'bg-status-neutral',
  brand:   'bg-brand-500',
  success: 'bg-status-success',
  error:   'bg-status-error',
  warning: 'bg-status-warning',
  info:    'bg-status-info',
  cc:      'bg-status-cc',
};

export function Badge({ tone = 'neutral', dot, className, children, ...rest }) {
  return (
    <span
      {...rest}
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-0.5 text-xs font-medium rounded-full',
        toneStyles[tone] ?? toneStyles.neutral,
        className,
      )}
    >
      {dot && <span className={cn('w-1.5 h-1.5 rounded-full', dotStyles[tone] ?? dotStyles.neutral)} aria-hidden />}
      {children}
    </span>
  );
}